import { iIconProps } from '../../icon';

export default function YouTubeIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 40 40' {...props}>
            <path d='M34.64 11.12c-.868-1.544-1.81-1.828-3.728-1.936C28.996 9.054 24.178 9 20.004 9c-4.182 0-9.002.054-10.916.182-1.914.11-2.858.392-3.734 1.938C4.46 12.662 4 15.318 4 19.994v.016c0 4.656.46 7.332 1.354 8.858.876 1.544 1.818 1.824 3.732 1.954 1.916.112 6.736.178 10.918.178 4.174 0 8.992-.066 10.91-.176 1.918-.13 2.86-.41 3.728-1.954.902-1.526 1.358-4.202 1.358-8.858v-.01-.006c0-4.678-.456-7.334-1.36-8.876zM16 26V14l10 6-10 6z' />
        </svg>
    );
}
